<template>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title" v-html="this.$t('AssemblyImpactNote.title')" />
      <p class="card-text" v-html="this.$t('AssemblyImpactNote.content')" />
    </div>
  </div>
</template>

<script>
import messages from 'locales/AssemblyImpactNote';

export default {
  name: 'AssemblyImpactNote',
  i18n: { messages },
};
</script>

<style scoped>

</style>
